import React from "react";

// import social data
import { social } from "../../constants";
import txn_logo from "../../assets/img/logo/tXn logo.png";

const Footer = () => {
  return (
    <footer className="bg-tertiary py-12">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 items-center justify-between">
          <div className="flex space-x-4 items-center justify-center">
            {social.map((item, index) => {
              const { href, iconFooter } = item;
              return (
                <a className="text-accent text-base " href={href} key={index}>
                  {iconFooter}
                </a>
              );
            })}
          </div>
          <div>
            {/* <img src={Logo} alt='' /> */}
            {/* <h1 className="text-2xl italic"> Tech X Neuro </h1> */}
            <a href="/" className="flex flex-row gap-2 items-center">
              <img
                src={txn_logo}
                alt=""
                className="w-[40px] h-[40px] rounded-full"
              />
              <h1 className="text-3xl italic"> Tech X Neuro </h1>
            </a>
          </div>
          <p className="text-paragraph opacity-80 text-[15px]">
            &copy; 2025. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
